import { FolderOpenOutlined } from "@ant-design/icons";
import Notiflix from "notiflix";
import { useMemo, useState } from "react";

//PROJECT IMPORTS
import cnt from "../../../../../services/definedConstant";
import { BOM } from "../../../../../services/definedMethod";

import {
  Button,
  Checkbox,
  Col,
  Modal,
  Pagination,
  Row,
  Space,
  Spin,
  Table,
  Tag,
  Tooltip,
  Typography,
} from "antd";

// import { apiConfig, labelConfig } from "../../../contractbooking.config";
import { apiConfig, labelConfig } from "../wallet.config";

import ArrowLeft from "@untitled-ui/icons-react/build/esm/ArrowLeft";
import ArrowRight from "@untitled-ui/icons-react/build/esm/ArrowRight";
import "../../../../../assets/styles/InterbankPlacement.css";
import styles from "../../../../../assets/styles/styles";
import DownloadTableButtons from "../../../../../components/layouts/enhancement/DownloadTableButtons";
import { useNavigate } from "react-router-dom";
import { handleFlgStatus } from "../../../../../components/facilities/AccountFacility";

const { Text } = Typography;

const SubWallet = (props) => {
  const {
    subWalletList,
    state,
    userData,
    showInterestChecked,
    setShowInterestChecked,
  } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  const pageSize = 10;

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return;
    }
    if (type === "next") {
      return;
    }
    return originalElement;
  };

  const totalPages = Math.ceil(subWalletList.length / pageSize);

  const paginatedData = subWalletList.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize,
  );

  // Reset to page 1 when filter changes
  useState(() => {
    setCurrentPage(1);
  }, [showInterestChecked]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text) => (
        <Tooltip title={text || "-"} placement="topLeft">
          {text ? BOM.SubstringFormat(text, 14) : "-"}
        </Tooltip>
      ),
    },
    {
      title: "Account No.",
      dataIndex: "nubanNumber",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text) => handleFlgStatus(text, {}, true),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <Tooltip title={`View Sub-wallet Detail`}>
            <Button
              type="primary"
              icon={<FolderOpenOutlined />}
              shape="round"
              size="small"
              // className="of-primaryBtnColor"
              className="detail-btn"
              style={{
                backgroundColor: "#FDF4FF",
                border: "none",
                color: "#ba24d5",
              }}
              disabled={!BOM.HasPermission("READ_SAVINGSACCOUNT")}
              onClick={() => (
                delete record.accounStatus,
                navigate("/detail-sub-wallet", {
                  state: {
                    ...record,
                    parentWalletAccountId: state.id,
                    subWalletList,
                  },
                })
              )}
            />
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <>
      <Table columns={columns} dataSource={paginatedData} pagination={false} />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 20,
        }}
      >
        <div>
          <Button
            style={{
              backgroundColor: "white",
              borderRadius: 8,
              border: "1px solid #D0D5DD",
              padding: "8px 12px",
              fontSize: "14px",
              fontWeight: "600",
            }}
            className="previous-button"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            <ArrowLeft style={{ width: "20px", height: "20px" }} /> Previous
          </Button>
        </div>

        {/* Centered Pagination */}
        <div style={{ flex: 1, textAlign: "center" }}>
          <Pagination
            className="payment-pagination"
            current={currentPage}
            total={subWalletList.length}
            pageSize={pageSize}
            onChange={(page) => setCurrentPage(page)}
            showSizeChanger={false}
            itemRender={itemRender}
            align="center"
          />
        </div>

        {/* Next button on the right */}
        <div>
          <Button
            style={{
              backgroundColor: "white",
              borderRadius: 8,
              border: "1px solid #D0D5DD",
              padding: "8px 12px",
              fontSize: "14px",
              fontWeight: "600",
            }}
            className="previous-button"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage >= totalPages}
          >
            Next <ArrowRight style={{ width: "20px", height: "20px" }} />
          </Button>
        </div>
      </div>
    </>
  );
};

export default SubWallet;
